const priorities: {[key: string]: number} = {};

export function addUnitPriority(unit: string, priority: number): void {
  priorities[unit] = priority;
}

/*
export function getPrioritizedUnits(unitsObj) {
  const units = [];
  let unit;
  for (unit in unitsObj) {
    if (unitsObj.hasOwnProperty(unit)) {
      units.push({ unit, priority: priorities[unit] });
    }
  }
  units.sort(function (a, b) {
    return a.priority - b.priority;
  });

  return units;
}
*/



// WEBPACK FOOTER //
// ../../../.tmp/chronos/units/priorities.ts